import { Color, DefaultValue, getDefaultTransition, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ResponseWrapperButton = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  height: 37px;
  padding: ${Spacing.S8} ${Spacing.S12};
  border: none;
  border-radius: ${DefaultValue.BorderRadius};
  outline: none;
  background-color: ${Color.Lavender50};
  cursor: pointer;
  appearance: none;
  ${getDefaultTransition('background-color')};

  &:hover {
    background-color: ${Color.Lavender100};
  }
`

export const IconWrapper = styled.figure`
  display: flex;
  margin-right: ${Spacing.S4};
`
